const WebSearchActionTypes = {
    REGISTER_FILTERABLE_LIST_VIEW: "REGISTER_FILTERABLE_LIST_VIEW",

    SET_HELP_OPEN_STATUS: "SET_HELP_OPEN_STATUS",

    SET_SEARCH_TERM: "SET_SEARCH_TERM",
    SET_PLACEHOLDER_TEXT: "SET_PLACEHOLDER_TEXT",
    SET_NEXT_SEARCH_URL: "SET_NEXT_SEARCH_URL",

    CLEAR_SEARCH_TERM: "CLEAR_SEARCH_TERM",

    STORE_SCROLL_TOP_POSITIONS: "STORE_SCROLL_TOP_POSITIONS",

    LOADING_QUICK_SEARCH_START: "LOADING_QUICK_SEARCH_START",
    LOADING_QUICK_SEARCH_FINISH: "LOADING_QUICK_SEARCH_FINISH",
    LOADED_QUICK_SEARCH_RESULTS: "LOADED_QUICK_SEARCH_RESULTS",

    DELETE_EVENT_START: "DELETE_EVENT_START",
    DELETE_EVENT_SUCCESS: "DELETE_EVENT_SUCCESS",
    DELETE_EVENT_FAIL: "DELETE_EVENT_FAIL",

    DELETE_NOTE_START: "DELETE_NOTE_START",
    DELETE_NOTE_SUCCESS: "DELETE_NOTE_SUCCESS",
    DELETE_NOTE_FAIL: "DELETE_NOTE_FAIL",

    DELETE_GRASSROOTS_ACTION_START: "DELETE_GRASSROOTS_ACTION_START",
    DELETE_GRASSROOTS_ACTION_SUCCESS: "DELETE_GRASSROOTS_ACTION_SUCCESS",
    DELETE_GRASSROOTS_ACTION_FAIL: "DELETE_GRASSROOTS_ACTION_FAIL",

    DELETE_FILE_START: "DELETE_FILE_START",
    DELETE_FILE_SUCCESS: "DELETE_FILE_SUCCESS",
    DELETE_FILE_FAIL: "DELETE_FILE_FAIL",

    DELETE_PUBLIC_ORGANIZATION_START: "DELETE_PUBLIC_ORGANIZATION_START",
    DELETE_PUBLIC_ORGANIZATION_SUCCESS: "DELETE_PUBLIC_ORGANIZATION_SUCCESS",
    DELETE_PUBLIC_ORGANIZATION_FAIL: "DELETE_PUBLIC_ORGANIZATION_FAIL",

    DELETE_CONTACT_START: "DELETE_CONTACT_START",
    DELETE_CONTACT_SUCCESS: "DELETE_CONTACT_SUCCESS",
    DELETE_CONTACT_FAIL: "DELETE_CONTACT_FAIL",

    PATCH_SUPPORTER_ACTION_START: "PATCH_SUPPORTER_ACTION_START",
    PATCH_SUPPORTER_ACTION_SUCCESS: "PATCH_SUPPORTER_ACTION_SUCCESS",
    PATCH_SUPPORTER_ACTION_FAIL: "PATCH_SUPPORTER_ACTION_FAIL",

    UPDATE_INLINE_APPEARANCE: "UPDATE_INLINE_APPEARANCE",

    POST_SAVED_SEARCH_START: "POST_SAVED_SEARCH_START",
    POST_SAVED_SEARCH_SUCCESS: "POST_SAVED_SEARCH_SUCCESS",
    POST_SAVED_SEARCH_FAIL: "POST_SAVED_SEARCH_FAIL",

    PATCH_SAVED_SEARCH_START: "PATCH_SAVED_SEARCH_START",
    PATCH_SAVED_SEARCH_SUCCESS: "PATCH_SAVED_SEARCH_SUCCESS",
    PATCH_SAVED_SEARCH_FAIL: "PATCH_SAVED_SEARCH_FAIL",

    // visualization stuff from here on out!
    SET_ACTIVE_VISUALIZATION: "SET_ACTIVE_VISUALIZATION",

    REGISTER_VISUALIZATION: "REGISTER_VISUALIZATION",
    SET_SECONDARY_GRAPH_KEYS: "SET_SECONDARY_GRAPH_KEYS",

    LOADING_VISUALIZATION_DATA_START: "LOADING_VISUALIZATION_DATA_START",
    LOADING_VISUALIZATION_DATA_FINISH: "LOADING_VISUALIZATION_DATA_FINISH",
    LOADED_VISUALIZATION_DATA: "LOADED_VISUALIZATION_DATA",

    LOAD_MAP_GEOGRAPHY_DATA_SUCCESS: "LOAD_MAP_GEOGRAPHY_DATA_SUCCESS",

    UPDATE_VISUALIZATION_SELECTION: "UPDATE_VISUALIZATION_SELECTION",
    CLEAR_VISUALIZATION_SELECTION: "CLEAR_VISUALIZATION_SELECTION",

    STORE_CURRENT_GRAPH: "SAVE_CURRENT_GRAPH",
    SHOW_STORED_GRAPH: "SHOW_STORED_GRAPH",
    HIDE_STORED_GRAPH: "HIDE_STORED_GRAPH",
    RENAME_STORED_GRAPH: "RENAME_STORED_GRAPH",
    DELETE_STORED_GRAPH: "DELETE_STORED_GRAPH",
    DELETE_ALL_STORED_GRAPHS: "DELETE_ALL_STORED_GRAPHS",

    STORE_EXTRA_VISUALIZATION_DATA: "STORE_EXTRA_VISUALIZATION_DATA",

    TOGGLE_TABLE_VIEW_START: "TOGGLE_TABLE_VIEW_START",
    TOGGLE_TABLE_VIEW_SUCCESS: "TOGGLE_TABLE_VIEW_SUCCESS",
    TOGGLE_TABLE_VIEW_FAIL: "TOGGLE_TABLE_VIEW_FAIL",

    TOGGLE_HIDE_FILTER_SET_START: "TOGGLE_HIDE_FILTER_SET_START",
    TOGGLE_HIDE_FILTER_SET_SUCCESS: "TOGGLE_HIDE_FILTER_SET_SUCCESS",
    TOGGLE_HIDE_FILTER_SET_FAIL: "TOGGLE_HIDE_FILTER_SET_FAIL",

    TOGGLE_NGG_EXPERIENCE_START: "TOGGLE_NGG_EXPERIENCE_START",
    TOGGLE_NGG_EXPERIENCE_SUCCESS: "TOGGLE_NGG_EXPERIENCE_SUCCESS",
    TOGGLE_NGG_EXPERIENCE_FAIL: "TOGGLE_NGG_EXPERIENCE_FAIL",

    // app/static/frontend/search-new/components/FilterSet/index.js
    // SearchFiltersTextareaComponent
    SEARCH_FILTERS_TERM: "SEARCH_FILTERS_TERM",

    AI_SEARCH_APPLIED: "AI_SEARCH_APPLIED",

    SET_MOBILE_FILTERS_OPEN_STATUS: "SET_MOBILE_FILTERS_OPEN_STATUS",
}

export const loadVisualizationDataTypes = {
    start: WebSearchActionTypes.LOADING_VISUALIZATION_DATA_START,
    success: WebSearchActionTypes.LOADED_VISUALIZATION_DATA,
    fail: WebSearchActionTypes.LOADING_VISUALIZATION_DATA_FINISH,
}

export const patchDeleteEvent = {
    start: WebSearchActionTypes.DELETE_EVENT_START,
    success: WebSearchActionTypes.DELETE_EVENT_SUCCESS,
    fail: WebSearchActionTypes.DELETE_EVENT_FAIL,
}

export const patchDeleteNote = {
    start: WebSearchActionTypes.DELETE_NOTE_START,
    success: WebSearchActionTypes.DELETE_NOTE_SUCCESS,
    fail: WebSearchActionTypes.DELETE_NOTE_FAIL,
}

export const patchDeleteGrassrootsAction = {
    start: WebSearchActionTypes.DELETE_GRASSROOTS_ACTION_START,
    success: WebSearchActionTypes.DELETE_GRASSROOTS_ACTION_SUCCESS,
    fail: WebSearchActionTypes.DELETE_GRASSROOTS_ACTION_FAIL,
}

export const patchDeleteFile = {
    start: WebSearchActionTypes.DELETE_FILE_START,
    success: WebSearchActionTypes.DELETE_FILE_SUCCESS,
    fail: WebSearchActionTypes.DELETE_FILE_FAIL,
}

export const patchDeleteContact = {
    start: WebSearchActionTypes.DELETE_CONTACT_START,
    success: WebSearchActionTypes.DELETE_CONTACT_SUCCESS,
    fail: WebSearchActionTypes.DELETE_CONTACT_FAIL,
}

export const patchDeletePublicOrganization = {
    start: WebSearchActionTypes.DELETE_PUBLIC_ORGANIZATION_START,
    success: WebSearchActionTypes.DELETE_PUBLIC_ORGANIZATION_SUCCESS,
    fail: WebSearchActionTypes.DELETE_PUBLIC_ORGANIZATION_FAIL,
}

export const patchSupporterAction = {
    start: WebSearchActionTypes.PATCH_SUPPORTER_ACTION_START,
    success: WebSearchActionTypes.PATCH_SUPPORTER_ACTION_SUCCESS,
    fail: WebSearchActionTypes.PATCH_SUPPORTER_ACTION_FAIL,
}

export const postSavedSearchTypes = {
    start: WebSearchActionTypes.POST_SAVED_SEARCH_START,
    success: WebSearchActionTypes.POST_SAVED_SEARCH_SUCCESS,
    fail: WebSearchActionTypes.POST_SAVED_SEARCH_FAIL,
}

export const patchSavedSearchTypes = {
    start: WebSearchActionTypes.PATCH_SAVED_SEARCH_START,
    success: WebSearchActionTypes.PATCH_SAVED_SEARCH_SUCCESS,
    fail: WebSearchActionTypes.PATCH_SAVED_SEARCH_FAIL,
}

export const toggleTableViewActionDict = {
    start: WebSearchActionTypes.TOGGLE_TABLE_VIEW_START,
    success: WebSearchActionTypes.TOGGLE_TABLE_VIEW_SUCCESS,
    fail: WebSearchActionTypes.TOGGLE_TABLE_VIEW_FAIL,
}

export const toggleHideFilterSetActionDict = {
    start: WebSearchActionTypes.TOGGLE_HIDE_FILTER_SET_START,
    success: WebSearchActionTypes.TOGGLE_HIDE_FILTER_SET_SUCCESS,
    fail: WebSearchActionTypes.TOGGLE_HIDE_FILTER_SET_FAIL,
}

export default WebSearchActionTypes
